export function formatDateInLocalTimezone(dateString) {
  const date = new Date(dateString);
  const options = {
    weekday: "short",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  };

  const formattedDate = date.toLocaleString("en-AU", options);

  // Convert AM/PM to lowercase and remove space between minutes and period
  return formattedDate.replace(
    /(\d+):(\d+)\s([AP]M)/i,
    (match, hour, minute, period) => {
      return `${hour}:${minute}${period.toLowerCase()}`;
    },
  );
}
